export const SERVICE_TYPES = {
    FOODSLABO: 'foodslabo',
    HOTELSLABO: 'hotelslabo',
} as const

export type ServiceType = typeof SERVICE_TYPES[keyof typeof SERVICE_TYPES]

export const PORTS = {
    APP: '3001',
    API: '3000',
} as const

export const API_HOSTS = {
    STG: 'stg.foods-labo.com',
    PROD: 'foods-labo.com',
} as const

export const SITUATION = {
    EMPLOYED: 10,
    UNEMPLOYED: 20,
} as const
